export default function GrandWave({ image }) {
  
  return (
                   <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1047.4 585.11"
    >
      <defs>
        <clipPath id="clip-forma">
          <path d="M0,585.11s178.31-132.24,384.71-128.46c206.39,3.78,317.84,60.7,661.44,4.53l1.25-461.19" />
          <path d="M1047.4,0s-152.07,66.5-243.83,93.7c-91.76,27.2-207.84,60.7-417.42,9.07C176.58,51.13,0,144.33,0,144.33v440.79" />
        </clipPath>
      </defs>
    
      <image
        width="1047.4"
        height="585.11"
        x="0"
        y="0"
        href={image}
        clipPath="url(#clip-forma)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
}
